module.exports = "images/doc-activity-add-empty-1.49b7813f88c5909061b658f16de855d2.png";